// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__EGX7G","card":"Menu_card__hx681"};